import { useEffect, useState } from 'react';
import DiscountTag from '../../../../../components/core/DiscountTag/DiscountTag';
import { useLineEdit } from '../../../../../contexts/LineEditContext/LineEditContext.hooks';
import { IPlanDiscountsTagProps } from './PlanDiscountsTag.types';
import { usePlansHooks } from '../../../../Plans/PlansHooks';
import { useAutopayDiscountTagStyles } from './PlanDiscountsTag.styles';

const PlansDiscountTag = (props: IPlanDiscountsTagProps) => {
    const styles = useAutopayDiscountTagStyles();

    const [discountMessages, setDiscountMessages] = useState<string[]>([]);

    const { CalculateDiscount } = useLineEdit();

    const {
        CalcMultiLineDiscount,
        GetPlanDisplayName,
        HasCustomerAppreciationDiscount,
        GetCustomerAppreciationDiscountAmountString
    } = usePlansHooks();

    useEffect(() => {
        const messages: string[] = [];

        if (props.planSelection.plan.autopayDiscount.hasDiscount && props.lineNumber <= 2) {
            messages.push(
                `$${CalculateDiscount(
                    props.planSelection.plan.linePrice[0],
                    props.planSelection.plan.autopayDiscount.discountType,
                    props.planSelection.plan.autopayDiscount.discountAmount
                )} per line/per month AutoPay discount applied after setting up AutoPay at <a href="myviaero.com">myviaero.com</a>.`
            );
        }

        if (props.planSelection.plan.linePrice.length > 1 && props.lineNumber > 1) {
            const multiLineDiscount = CalcMultiLineDiscount(
                props.planSelection.plan,
                props.lineNumber
            );
            if (multiLineDiscount > 0) {
                messages.push(
                    `Monthly discount for ${GetPlanDisplayName(
                        props.planSelection.plan
                    )} plan Line ${props.lineNumber}: $${multiLineDiscount.toFixed(2)}`
                );
            }
        }

        if (HasCustomerAppreciationDiscount(props.planSelection)) {
            messages.push(
                `${GetCustomerAppreciationDiscountAmountString(props.planSelection)} ${props.planSelection.customerAppreciationDiscount?.name} Appreciation Discount`
            );
        }

        setDiscountMessages(messages);
    }, [props]);

    return discountMessages.length > 0 ? (
        <div className={styles.autopayDiscountTag}>
            <DiscountTag taglines={discountMessages} />
        </div>
    ) : (
        <></>
    );
};

export default PlansDiscountTag;
